module.exports = __webpack_public_path__ + "img/video1.2f5233e9.jpg";